import { useCallback } from 'react'

import { Button, Heading } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { FullScreen } from '@modals/layout'
import { Center } from '@shared/components/layout'
import useTranslation from 'next-translate/useTranslation'

export const DepositSuccess: React.FC = () => {
  const { t } = useTranslation('ace')
  const { t: tCommon } = useTranslation('common')
  const { close } = useModal()

  const handleCtaClick = useCallback(() => close(), [close])

  return (
    <FullScreen totalSteps={5}>
      <Center className="font-circular" variant="horizontal">
        <Heading
          alignment="center"
          iconName="CheckCircleSolid"
          layout="vertical"
          status="success"
          variant="page/sm"
        >
          <Heading.Header as="h2" className="mt-12">
            {tCommon('success')}
          </Heading.Header>
          <Heading.Intro as="p" className="w-168">
            {t('deposit.depositSuccess.description')}
          </Heading.Intro>
        </Heading>

        <Center variant="horizontal">
          <Button
            className="mt-12 w-full"
            onClick={handleCtaClick}
            size="base"
            variant="primary"
          >
            {t('deposit.depositSuccess.cta')}
          </Button>
        </Center>
      </Center>
    </FullScreen>
  )
}
